import { render, staticRenderFns } from "./DocumentViewCard4.vue?vue&type=template&id=47300ea2&scoped=true"
import script from "./DocumentViewCard4.vue?vue&type=script&lang=js"
export * from "./DocumentViewCard4.vue?vue&type=script&lang=js"
import style0 from "./DocumentViewCard4.vue?vue&type=style&index=0&id=47300ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47300ea2",
  null
  
)

export default component.exports